import { IFileResponse } from '../../../interfaces/businessData';
import {
  ICompanyRewardsInfo,
  ILoadBalanceData,
  IRewardsDeposit,
  IRewardsHistoryDetails,
  ISendPointsData,
  IRewardsOrderResponse,
  IRewardsFileValidation,
  ISendPointsFileData,
  IRewardsGetOrderErrorFile,
  IRewardsEmailTemplate
} from '../../../interfaces/rewards';
import { MOCK_DOWNLOAD_FILE_RESPONSE } from '../../../mocks/metrics';
import {
  MOCK_POINTS_FILE_VALIDATION_RESPONSE,
  MOCK_REWARDS_DEPOSIT_RESPONSE,
  REWARDS_INFO_MOCK_RESPONSE,
  REWARDS_ORDER_DETAIL_MOCK_RESPONSE,
  MOCK_REWARDS_ORDER_ERROR_FILE_RESPONSE,
  REWARDS_ORDER_MOCK_RESPONSE,
  MOCK_EMAIL_TEMPLATE
} from '../../../mocks/rewards';
import { HttpService, HttpServiceServer } from '../../http/httpService';

export class Rewards {
  static async getRewardsInfo(companyId: string): Promise<ICompanyRewardsInfo> {
    const response = await HttpService.get<ICompanyRewardsInfo>(
      `rewards/${companyId}/info`,
      {},
      REWARDS_INFO_MOCK_RESPONSE
    );
    return response.data;
  }

  static async loadBalance(companyId: string, loadBalance: ILoadBalanceData): Promise<IRewardsDeposit> {
    const response = await HttpServiceServer.post<IRewardsDeposit>(
      `companies/${companyId}/rewards/deposits`,
      loadBalance,
      {},
      MOCK_REWARDS_DEPOSIT_RESPONSE
    );
    return response.data;
  }

  static async sendPoints(
    companyId: string,
    sendPoints?: ISendPointsData,
    sendPointsByFile?: ISendPointsFileData
  ): Promise<IRewardsDeposit> {
    const payload = sendPoints || sendPointsByFile;
    const response = await HttpServiceServer.post<IRewardsDeposit>(
      `/companies/${companyId}/rewards/send-points`,
      payload,
      {},
      MOCK_REWARDS_DEPOSIT_RESPONSE
    );
    return response.data;
  }

  static async getFilteredOrders(
    companyId: string,
    type: string,
    searchValue?: string,
    status?: string
  ): Promise<IRewardsOrderResponse> {
    const response = await HttpService.get<IRewardsOrderResponse>(
      `rewards/${companyId}/orders`,
      { params: { type, searchValue, status } },
      REWARDS_ORDER_MOCK_RESPONSE
    );
    return response.data;
  }

  static async getOrderDetails(
    companyId: string,
    orderId: string,
    searchValue?: string,
    status?: string
  ): Promise<IRewardsHistoryDetails> {
    const response = await HttpService.get<IRewardsHistoryDetails>(
      `rewards/${companyId}/order_details/${orderId}`,
      { params: { searchValue, status } },
      { data: REWARDS_ORDER_DETAIL_MOCK_RESPONSE }
    );
    return response.data;
  }

  static async getPointsTemplate(companyId: string, countryCode: string): Promise<IFileResponse> {
    const response = await HttpServiceServer.get<IFileResponse>(
      `companies/${companyId}/rewards/points/template/${countryCode}`,
      {},
      MOCK_DOWNLOAD_FILE_RESPONSE
    );
    return response.data;
  }

  static async validatePointsFile(companyId: string, base64: string): Promise<IRewardsFileValidation> {
    const response = await HttpServiceServer.post<IRewardsFileValidation>(
      `companies/${companyId}/rewards/points/validate-file`,
      { base64: base64 },
      {},
      MOCK_POINTS_FILE_VALIDATION_RESPONSE
    );
    return response.data;
  }

  static async sendPointsFile(companyId: string, sendPoints: ISendPointsFileData): Promise<IRewardsDeposit> {
    const response = await HttpServiceServer.post<IRewardsDeposit>(
      `/companies/${companyId}/rewards/send-points`,
      sendPoints,
      {},
      MOCK_REWARDS_DEPOSIT_RESPONSE
    );
    return response.data;
  }

  static async getOrderErrorFile(companyId: string, orderId: string): Promise<IRewardsGetOrderErrorFile> {
    const response = await HttpServiceServer.get<IRewardsGetOrderErrorFile>(
      `/companies/${companyId}/rewards/orders/${orderId}/errors`,
      {},
      MOCK_REWARDS_ORDER_ERROR_FILE_RESPONSE
    );
    return response.data;
  }

  static async getEmailTemplate(companyId: string, templateName: string): Promise<string> {
    const response = await HttpServiceServer.get<IRewardsEmailTemplate>(
      `/companies/${companyId}/rewards/points/email-template/${templateName}`,
      {},
      MOCK_EMAIL_TEMPLATE
    );
    return response.data.template;
  }
}

export default Rewards;
